var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFoundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED5F5F",
    d: "M15.040 12.512l-6.096-10.208c-0.432-0.72-1.472-0.784-1.92-0.080l-6.047 10.272c-0.48 0.752 0.064 1.905 0.959 1.905h12.128c0.88 0 1.424-1.136 0.976-1.888zM7.968 12.672c-0.432 0-0.784-0.351-0.784-0.784s0.351-0.784 0.784-0.784c0.432 0 0.784 0.351 0.784 0.784s-0.351 0.784-0.784 0.784zM8.8 9.792c0 0.432-0.368 0.784-0.8 0.784s-0.8-0.351-0.8-0.784v-4.097c0-0.432 0.368-0.784 0.8-0.784s0.8 0.351 0.8 0.784v4.097z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundIcon);
export default __webpack_public_path__ + "static/media/not-found-icon.8070d34503ce56e70e0d15d5585ef3fa.svg";
export { ForwardRef as ReactComponent };